
<template>
     <div>
      <div class="flx-center">
            <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/head_img1.jpg) no-repeat center' }"></div>
        </div>
  <div class="footerBottom" style="">
    <div class="container">
    <div class="flx corporateBox" style="margin-top: 140px;">
      <img class="serviceBoxImg" :src="$ossUrl+'images/business/aaf_Icon.png'" alt="">

      <div class="corporateTitle" style="border-right: 1px solid #E2E2E2;">企业愿景及目标</div>
      <div class="flx-wrap">
        <div class="corporateContent">
          <div>企业愿景</div>
          <div>跨境电商全球物流优选平台，帮助中国制造安全、稳定、快捷地智达全球</div>
        </div>
        <div class="corporateContent">
          <div>五年目标</div>
          <div>助力跨境电商五万家企业成功出海</div>
        </div>
      </div>
    </div>
  </div>
  <div style="background-color: #F8F8F8;height: 650px;" :style="{ background: 'url(' + $ossUrl + 'images/核心价值观.png) no-repeat center' }">
    <div class="container">
    <div class="flx coreValue" style="margin-top: 140px;padding: 70px 0;">
      <div class="coreValueBox_position">
        <img class="coreImg" :src="$ossUrl+'images/about/coreValueBottom.png'">

        <!-- <div class="corporateTitle"  style="width: 100%;height: 100%;"  >
          核心价值观
        </div> -->
        <!-- <div class="flx " style="margin-top: 15px;width: 30%;" > -->
          <!-- <el-row>
          <el-col :span="24" v-for="(item,index) in coreValueList" :key="index">
            <div>{{ item.title }}</div>
          </el-col>

        </el-row> -->
       
        <!-- </div> -->
      </div>
      <!-- <div style="margin-left: 140px;">
          <img :src="$ossUrl+'images/about/coreValue.png'" alt="">
        </div> -->
    </div>
  </div>
  </div>
  <div class="container">
    <div style="margin-top: 140px;">
      <div class="corporateTitle" >企业团队</div>
    
    </div>
  </div>
  <!-- <el-carousel :interval="100000" type="card"  arrow="always" ref="carousel">
       <el-carousel-item v-for="(item,index) in imgsList" :key="index" >
         <div style="width: 800px;">
          <img :src="item.img" alt="">
         </div>
       </el-carousel-item>
     </el-carousel> -->
     <div class="main_show">
      <div class="main_show_Carrousel">

      <Carrousel v-if="buttons" ref="swiperComp"></Carrousel>
      <div class="swiper-button-nexts" @click="nextSlide" :style="{ background: 'url(' + $ossUrl + 'images/about/next.png) no-repeat center' }"></div> 
    </div>
     </div>

  </div>
     </div>
</template>
<script>
import Carrousel from "./Carrousel.vue"; 

/**
 * Index-1 component
 */
export default {
    name:"about",
  components: {
    Carrousel,
  },
  data(){
    return {
      activeName: 'second',
      currentIndex: 0,
      activeIndex: 2, // 默认选中第一个按钮
      buttons: [
        { label: '关于美通',transportMode:'OCEAN' },
        { label: '联系我们',transportMode:'AIR' },
        { label: '企业文化',transportMode:'RAIL' },
        { label: '企业招聘',transportMode:'ROAD' }
      ],
      coreValueList:[
        {title:'开放协同',content:'结果导向、勇于承担、乐于奉献'},
        {title:'团结奋斗',content:'拥抱变化、持续改进、敢于突破'},
        {title:'诚实守信',content:'持续学习、学以致用、日日精进'},
        {title:'开拓创新',content:'乐观自信、向上向善、永不言弃'},
        // {title:'合作',content:'开放包容、求同存异、共享发展'},
        // {title:'奋斗',content:'脚踏实地、锐意进取、奋发图强'},
      ],
      imgsList:[
        {img:this.$ossUrl+'images/about/company/picture1.png'},
        {img:this.$ossUrl+'images/about/company/picture2.png'},
        {img:this.$ossUrl+'images/about/company/picture1.png'},
        {img:this.$ossUrl+'images/about/company/picture1.png'},
        {img:this.$ossUrl+'images/about/company/picture1.png'},
      ]
    }
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event);
      },
    setActive(item,index) {
      if(index === 1){
        this.$router.push({
          name:'connection'
        })
      }else if(index === 2){
        this.$router.push({
          name:'corporateCulture'
        })
      }else if(index === 3){
        this.$router.push({
          name:'inviteJob'
        })
      }else {
        this.$router.push({
          name:'about'
        })
      }
      // this.activeIndex = index;
      

    },
    nextSlide() {
      this.$refs.swiperComp.setupNextButton(); // 通过ref引用调用子组件方法
    },
  }
};
</script>
<style src="../index.css" scoped></style>